export default __webpack_public_path__ + "657ab749cea8b518d8df4d6fa816fa7c.svg";